/* eslint-disable no-prototype-builtins */
import Box from "@mui/material/Box";
import Dialog from "@mui/material/Dialog";
import React from "react";

import Button from "../../../../../../../design/button";
import DialogWrapper from "../../../../../../../design/dialog-wrapper";
import ConfigurationForm from "./configuration-form";

type SeniorityBasedConfigurationDialogProps = {
	open: boolean;
	handleClose: () => void;
	shiftAllocationRules: any;
	setShiftAllocationRules: any;
	id?: number;
	locationData: any;
	setLocationData: any;
};

const SeniorityBasedConfigurationDialog = ({
	open,
	handleClose,
	shiftAllocationRules,
	setShiftAllocationRules,
	id,
	locationData,
	setLocationData,
}: SeniorityBasedConfigurationDialogProps) => {
	const config = shiftAllocationRules.find(
		(rule: { shiftAllocationTypeId: number }) =>
			rule.shiftAllocationTypeId === id
	);

	return (
		<Dialog
			open={open}
			onClose={handleClose}
			aria-describedby='alert-dialog-slide-description'
			maxWidth={false}
		>
			<DialogWrapper
				dialogTitle='Seniority based allocation - configuration'
				dialogSubTitle={
					"Configure the rules that you want to apply for seniority based allocation"
				}
				dialogContent={
					<ConfigurationForm
						shiftAllocationRules={shiftAllocationRules}
						setShiftAllocationRules={setShiftAllocationRules}
						id={id}
					/>
				}
				actionButtons={
					<Box
						display='flex'
						justifyContent='space-between'
						width='160px'
						mt={-10}
					>
						<Button color='primary' variant='text' onClick={handleClose}>
							Cancel
						</Button>
						<Button
							variant='contained'
							color='primary'
							type='submit'
							onClick={() => {
								setLocationData({
									...locationData,
									allocationSettings: shiftAllocationRules,
								});
								handleClose();
							}}
							disabled={
								config &&
								!config.defaultWindowSizeMins &&
								!config.urgentWindowSizeMins
							}
						>
							Done
						</Button>
					</Box>
				}
			/>
		</Dialog>
	);
};

export default SeniorityBasedConfigurationDialog;
